import React from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Mechanism } from './components/sections/Mechanism';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { ForWhom } from './components/sections/ForWhom';
import { HowItWorks } from './components/sections/HowItWorks';
import { Proof } from './components/sections/Proof';
import { FAQ } from './components/sections/FAQ';
import { OfferBlock } from './components/sections/OfferBlock';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FAF7F2] text-[#1C1917] font-sans selection:bg-[#C26D5C] selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Mechanism data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <ForWhom data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Proof data-id="element-8" />
        <FAQ data-id="element-9" />
        <OfferBlock data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}